const error = {
  'common.error.clientError':
    '다시 시도해 주시기 바랍니다. 지속적으로 오류가 발생할 경우 관리자 혹은 고객지원실로 연락해 주시기 바랍니다.',

  'common.error.serverError':
    '다시 시도해 주시기 바랍니다. 지속적으로 오류가 발생할 경우 관리자 혹은 고객지원실로 연락해 주시기 바랍니다.',
  'common.temporarySave': '작성한 내용이 자동 임시저장 되었습니다.',
  'common.error.temporarySave': '자동 임시 저장에 실패하였습니다. 다시 시도해 주세요.',
  'common.error.invalidPageRequest': '잘못된 페이지 요청입니다.',
  'common.error.v2request': '데이터를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.',
  'common.error.forbidden': '권한 없어 해당 요청을 처리할 수 없습니다.',
  'common.error.notLogin': '로그인이 필요합니다.',

  'gateway.error.token.invalid': '잘못된 인증 토큰입니다.',
  'gateway.error.token.create': '인증 토큰 생성에 실패하였습니다.',
  'gateway.error.token.read': '인증 토큰 정보를 읽을 수 없습니다.',
  'gateway.error.mobile.header.create': '모바일 헤더 생성에 실패하였습니다.',
  'gateway.error.header.invalid': '잘못된 헤더가 있습니다.',
  'gateway.error.blacklisted.ipaddress': '블랙리스트 처리된 IP Address 입니다.',
  'gateway.error.data.convert': '데이터 타입 변경에 실패하였습니다.',

  'member.error.user.notFound': '로그인이 필요합니다.',
  'member.error.traveler.notFound': '여행자 정보가 없습니다.',
  'member.error.traveler.read': '여행자 정보를 불러올 수 없습니다.',
  'member.error.traveler.write': '여행자 정보를 저장할 수 없습니다.',
  'member.error.manager.notFound': '매니저 정보가 없습니다.',
  'member.error.manager.read': '매니저 정보를 불러올 수 없습니다.',
  'member.error.manager.write': '매니저 정보를 저장할 수 없습니다.',
  'member.error.manager.privacyAccessNotGranted': '개인정보 열람 권한이 없습니다.',
  'member.error.partner.notFound': '파트너 정보가 없습니다.',
  'member.error.partner.read': '파트너 정보를 불러올 수 없습니다.',
  'member.error.partner.write': '파트너 정보를 저장할 수 없습니다.',
  'member.error.message.sendFail': '메세지 발송에 실패하였습니다.',
  'member.error.message.kafka': '메시지 큐 연동에 실패하였습니다.',
  'member.error.bankAccount.notFound': '등록된 환불 계좌가 없습니다.',
  'member.error.bankAccount.invalid': '유효하지 않은 계좌 번호입니다.',
  'member.error.wishlist.fail': '위시리스트 처리에 실패하였습니다.',

  'accommodation.error.invalidParameter': '문제가 발생했습니다. 다시 시도해주세요.',
  'accommodation.error.notFoundProduct': '상품 정보를 확인할 수 없습니다.',
  'accommodation.error.oneMoreReservationExist': '예약이 존재하는 상품은 삭제할 수 없습니다.',
  'accommodation.error.invalidProductUpdateStatus':
    '상품 상태 변경에 실패했습니다. 다시 시도해주세요.',
  'accommodation.error.productEmptyCity':
    '나라/도시가 설정되지 않았습니다. 설정 후 다시 시도해주세요.',
  'accommodation.error.notEnoughProductImages': '4개 이상의 상품 이미지가 필요합니다.',
  'accommodation.error.invalidParameter.2': '사진 삭제에 실패했습니다. 다시 시도해주세요.',
  'accommodation.error.invalidParameter.3': '위치 정보 저장에 실패했습니다. 다시 시도해주세요.',
  'accommodation.error.notFoundOption': '옵션을 찾을 수 없습니다.',
  'accommodation.error.notFoundProduct.2': '기본 가격표는 삭제할 수 없습니다.',
  'accommodation.error.notFoundPriceGroup': '가격표를 찾을 수 없습니다.',
  'accommodation.error.defaultPriceGroupUpdateRequested': '기본 가격표는 수정할 수 없습니다.',
  'accommodation.error.notFoundReservation': '예약 정보를 확인할 수 없습니다.',
  'accommodation.error.reservationNotOwned': '예약자 정보가 일치하지 않습니다.',
  'accommodation.error.invalidImageFileExtension':
    '지원하지 않은 파일 포맷입니다. JPG, JPEG, PNG 파일을 사용해주세요.',
  'accommodation.error.imageFileSizeExceed':
    '사진 파일의 크기가 너무 큽니다. 3MB 이하의 사진을 사용해주세요.',
  'accommodation.error.imageUploadFailed': '사진 저장에 실패했습니다. 사진을 다시 올려주세요.',
  'accommodation.error.imageMetaDataNotMatched':
    '사진 저장에 실패했습니다. 사진을 다시 올려주세요.',
  'accommodation.error.notSavedImagePosted': '사진 저장에 실패했습니다. 사진을 다시 올려주세요.',

  'review.error.reviewAlreadyExist': '이미 후기가 작성되었습니다.',
  'review.error.invalidReviewScore':
    '후기 평점이 올바르지 않습니다. 다시 확인하신 후 시도해주세요.',
  'review.error.invalidReviewScoreKey':
    '후기 상세 평점이 올바르지 않습니다. 다시 확인하신 후 시도해주세요.',
  'review.error.notFoundReview': '후기 정보를 확인할 수 없습니다.',
  'review.error.reviewNotWritableReservationStatus':
    '예약완료가 아닌 경우, 후기를 작성할 수 없습니다.',
  'review.error.reviewNotOwned': '후기 작성/수정/삭제 권한이 없습니다.',
  'review.error.reviewUpdatableTimeExceeded':
    '최초 후기 작성 시간으로부터 48시간이 지나 수정/삭제가 불가능합니다.',

  'order.invalid.reservation.status': '예약 확정에 실패했습니다. 다시 시도해주세요.',
  'order.invalid.request': '주문서 생성에 실패했습니다. 다시 시도해주세요.',
  'order.invalid.form': '주문서 생성에 실패했습니다. 다시 시도해주세요.',
  'order.invalid.order.status': '예약 정보가 유효하지 않습니다. 예약상태를 확인해주세요.',
  'order.not.cancelable': '취소할 수 없는 예약입니다. 예약상태를 확인해주세요.',
  'order.fail.order': '예약이 성공적으로 완료되지 않았습니다. 다시 시도해주세요.',
  'order.product.occupy.fail': '예약이 성공적으로 완료되지 않았습니다. 다시 시도해주세요.',
  'order.coupon.use.fail': '쿠폰 사용에 실패했습니다. 쿠폰을 다시 적용해주세요.',
  'order.point.use.fail': ':포인트 사용에 실패했습니다. 포인트를 다시 적용해주세요.',
  'order.payment.request.fail': '결제에 실패했습니다. 다시 시도해주세요.',
  'order.form.not.found': '주문서를 찾을 수 없습니다.',
  'order.validation.fail.amount': '주문 금액정보가 유효하지 않습니다.',

  'reservation.history.button.contactPartner': '파트너에게 문의',
  'reservation.history.button.contactCustomerCenter': '고객지원실에 문의',
  'reservation.history.button.cancelReservation': '예약 취소',
  'reservation.history.button.writeReview': '후기 남기고 쿠폰 받기',
  'reservation.history.button.viewReview': '내 후기 보기',
  'reservation.history.button.bookAgain': '다시 예약하기',
  'reservation.history.button.locationCheckLabel': '위치 확인하기',
  'reservation.history.button.accommodationLocationCheck': '숙소 위치 확인',
  'reservation.history.button.tourLocationCheck': '만나는 장소 확인',
  'reservation.history.button.viewQuote': '여행견적서 보기',
  'reservation.history.button.businessContact': '업체에 전화하기',
  'reservation.history.button.checkIn': '입장 확인',
  'reservation.history.button.writeReviewWithCoupon': '후기 작성하고 쿠폰 받기',
  'reservation.history.button.searchMoreLabel': '6개월 더 조회하기',
  'reservation.history.button.guidance': '사용 방법 확인',
  'reservation.history.button.changeSchedule': '일정 변경',
  'reservation.history.ongoing.emptyTitle': '예정된 여행이 없습니다',
  'reservation.history.ongoing.emptyDescription1': '어디로 떠날지 고민 중이신가요?',
  'reservation.history.ongoing.emptyDescription2': '',
  'reservation.history.finish.emptyTitle': '지난 여행이 없습니다',
  'reservation.history.finish.emptyDescription1': '6개월 내 지난 여행이 없습니다.',
  'reservation.history.finish.emptyDescription2': '기간을 다시 설정해보세요.',
  'reservation.history.cancel.emptyTitle': '취소된 여행이 없습니다',
  'reservation.history.cancel.emptyDescription1': '6개월 내 취소된 여행이 없습니다.',
  'reservation.history.cancel.emptyDescription2': '기간을 다시 설정해보세요.',

  'reservation.button.ticketConfirmPurchase': '사용 완료',
  'reservation.button.tourConfirmPurchase': '여행 완료',

  'claim.error.invalidStatusForChange':
    '클레임 정보를 찾을 수 없습니다. 클레임 상태를 확인해주세요.',
  'claim.error.invalidStatusForChange.2':
    '클레임 상태 변경에 실패했습니다. 클레임 상태를 확인해주세요.',
  'claim.error.invalidStatusForChange.3': '종료되지 않은 클레임이 있습니다.',
  'claim.error.invalidStatusForChange.4': '환불이 완료된 클레임 입니다.',
  'claim.error.memo.notFound': '이미 삭제된 메모 입니다.',
  'claim.error.invalidStatusForChange.5': '이미 완료된 클레임 입니다.',

  'coupon.template.error.overMaxPublishableCount': '쿠폰이 모두 소진되어 등록이 불가능합니다.',
  'coupon.common.error.invalidUser': '사용자 정보가 올바르지 않습니다.',
  'coupon.userMapping.error.empty': '쿠폰정보를 조회할 수 없습니다.',
  'coupon.template.error.duplicatePromotionCode': '프로모션 코드가 중복입니다.',
  'coupon.common.error.emptyParameter': '문제가 발생했습니다. 다시 시도해주세요.',
  'coupon.common.error.productClientApiError': '상품 정보 연동 중 에러가 발생했습니다.',
  'coupon.template.error.empty': '쿠폰정보를 조회할 수 없습니다.',
  'coupon.publish.error.invalidTemplateId':
    '쿠폰 등록에 실패했습니다. 쿠폰 템플릿 아이디를 다시 확인해주세요.',
  'coupon.publish.error.invalidPromotionCode': '쿠폰 등록에 실패했습니다. 쿠폰코드를 확인해주세요.',
  'coupon.template.error.invalidUsableStatus': '사용이 중지된 쿠폰입니다.',
  'coupon.template.error.invalidPublishableStatus': '사용이 중지된 쿠폰입니다.',
  'coupon.use.error.invalidCouponCondition':
    '쿠폰 사용 조건에 맞지 않아 쿠폰을 사용할 수 없습니다.',
  'coupon.template.error.invalidActivatedDate': '지급 기간이 지난 쿠폰입니다.',

  'coupon.accommodation.war.invalidPublishableDate': '이벤트 기간이 아닙니다.',
  'coupon.accommodation.war.invalidPublishableTime': '쿠폰 발급 시간이 아닙니다.',
  'coupon.accommodation.war.alreadyCouponPublished': '타 서비스에서 다운로드 받은 쿠폰이 있습니다.',
  'coupon.accommodation.war.alreadyCouponPublishedInMrt': '이미 다운로드 받은 쿠폰이 있습니다.',
  'coupon.accommodation.war.overPublishableCouponAmount':
    '이벤트 쿠폰 물량이 모두 소진되어 더 이상 쿠폰을 발급할 수 없습니다.',
  'coupon.accommodation.war.notUsableCoupon': '요청하신 정보가 잘못되었습니다.',
  'coupon.accommodation.war.invalidNiceAuthInfo': '본인 인증이 불가합니다.',
  'coupon.accommodation.war.notExistAuthentication': '인증 정보가 존재하지 않습니다.',
  'coupon.accommodation.war.notEnoughAuthInfo': '인증 정보가 정확하지 않습니다.',
  'coupon.accommodation.war.alreadyExistAuthentication': '이미 발급 및 사용된 쿠폰이 있습니다.',

  'error.10001': '최근 검색어를 모두 지우시겠습니까?',
  'error.10002': '이 지역에는 예약 가능한 한인민박이 없습니다. 검색 범위를 넓혀보세요.',
  'error.10003': '상품을 불러오는데 실패했습니다. 다시 시도해주세요.',
  'error.10004': '인기 여행지를 불러오는데 실패했습니다. 다시 시도해주세요.',
  'error.10005': '인기 여행지를 불러오는데 실패했습니다. 다시 시도해주세요.',
  'error.10006': '검색 결과가 없습니다.',
  'error.10007': '필터를 초기화하고 다시 검색해주세요.',
  'error.10008': '다른 조건으로 다시 검색해주세요.',

  'error.20001': '전용 할인쿠폰 정보를 가져오지 못했습니다. 다시 시도해주세요.',

  'error.30001': '영어로 2자 이상 입력해주세요.',
  'error.30002': '영어로 2자 이상 입력해주세요.',
  'error.30003': '한글로 2자 이상 입력해주세요.',
  'error.30004': '성별을 선택해주세요.',
  'error.30005': '숫자로 8자를 입력해주세요.',
  'error.30006': '한글로 2자 이상 입력해주세요.',
  'error.30007': '휴대전화 번호를 형식에 맞게 입력해주세요.',
  'error.30008': '예약자 이름을 2자 이상 입력해주세요.',
  'error.30009': '이메일 주소를 형식에 맞게 입력해주세요.',
  'error.30011': '연령대를 선택해주세요.',
  'error.30012': '여행 유형을 선택해주세요.',
  'error.30013': '숫자로 6자를 입력해주세요.',
  'error.30014': '유효한 생년월일을 입력해주세요.',
  'error.30015': '예약자 이름을 알맞게 입력해주세요. 한글과 영문을 혼용하여 입력할 수 없습니다.',
  'error.30016': '기타 예약 정보를 알맞게 입력해주세요. 최대 100자까지 입력할 수 있습니다.',
  'error.30017': '날짜를 선택해주세요.',
  'error.30018': '시간을 선택해주세요.',
  'error.30019': '날짜, 시간을 선택해주세요.',
  'error.30020': '특수문자, 이모티콘은 사용할 수 없어요.',
  'error.30021': '옵션을 선택해주세요.',
  'error.30022': '영문 성을 입력해주세요.',
  'error.30023': '영문 이름을 입력해주세요.',
  'error.30024': '한글로 수령인 이름을 입력해주세요.',
  'error.30025': '여권 번호를 입력해주세요.',
};

export default error;
